"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _IdMapping = _interopRequireDefault(require("@rsuite/icon-font/lib/people/IdMapping"));

// Generated by script, don't edit it please.
var IdMapping = (0, _createSvgIcon["default"])({
  as: _IdMapping["default"],
  ariaLabel: 'id mapping',
  category: 'people',
  displayName: 'IdMapping'
});
var _default = IdMapping;
exports["default"] = _default;
module.exports = exports.default;